import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AddDealerLayer from "../../../components/Admin/AddDealerLayer";

const AddDealer = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <AddDealerLayer />
      </MasterLayout>
    </>
  );
};

export default AddDealer;
